import { render } from "./ApplicantForm.vue?vue&type=template&id=5b82ecfc&lang=pug"
import script from "./ApplicantForm.vue?vue&type=script&lang=js"
export * from "./ApplicantForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__